import { useSessao } from '../../../auth/contexto'
import { Botao } from '../../../components/Botao'
import { AvisoDeErro } from '../../../components/Estados'
import { TEXTOS } from '../../../lib/glossario'
import { useSincronizarAgora, useSituacaoDaSincronizacao } from '../../../api/queries/chamados'
import type { UsuarioLogado } from '../../../types/gmud'

/** Os mesmos papéis do `@PreAuthorize` do servidor — conveniência de tela, não regra. */
const PAPEIS_QUE_SINCRONIZAM = ['FISCAL', 'ADMIN']

/**
 * O estado da atualização automática, e o botão de rodar agora.
 *
 * Duas frases importam aqui, e as duas vêm do servidor: se a busca pode rodar (sem os tokens do
 * e-Niterói ela não pode, e a mensagem diz o que falta) e o que a última rodada fez — que aparece
 * no histórico de cargas logo abaixo, como qualquer carga.
 */
export function SituacaoDaSincronizacao() {
  const { usuario } = useSessao()
  const { data: situacao, isPending } = useSituacaoDaSincronizacao()
  const sincronizar = useSincronizarAgora()

  if (isPending || !situacao) {
    return null
  }

  return (
    <section className="cartao space-y-3 p-5" aria-label={TEXTOS.sincronizacao.titulo}>
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-base font-semibold text-slate-900">{TEXTOS.sincronizacao.titulo}</h2>
          <p className="mt-1 max-w-3xl text-sm text-slate-500">{TEXTOS.sincronizacao.ajuda}</p>
        </div>
        {situacao.disponivel && podeSincronizar(usuario) && (
          <Botao
            aparencia="secundario"
            tamanho="pequeno"
            onClick={() => sincronizar.mutate()}
            disabled={sincronizar.isPending}
          >
            {sincronizar.isPending ? TEXTOS.sincronizacao.buscando : TEXTOS.sincronizacao.botao}
          </Botao>
        )}
      </header>

      {!situacao.disponivel && (
        <div className="rounded-md border border-amber-200 bg-amber-50 p-3">
          <p className="text-sm font-medium text-amber-900">{TEXTOS.sincronizacao.indisponivelTitulo}</p>
          {situacao.motivoIndisponivel && (
            <p className="mt-1 text-sm text-amber-800">{situacao.motivoIndisponivel}</p>
          )}
        </div>
      )}

      {sincronizar.isError && <AvisoDeErro erro={sincronizar.error} />}
      {sincronizar.data && <p className="text-sm text-slate-600">{sincronizar.data.mensagem}</p>}
    </section>
  )
}

function podeSincronizar(usuario: UsuarioLogado | null): boolean {
  return usuario?.papeis.some((papel) => PAPEIS_QUE_SINCRONIZAM.includes(papel)) ?? false
}
